export const ARG_PREFIX_NUMBER = '+549';
export const CORRECT_CHARACTER = '11';
